import { Container, Row, Col } from "react-bootstrap";
import { useState } from "react";
import ai_analysis from "../../../images/Emotion_analysis.png";
import discussion from "../../../images/discussion.png";
import ai_thinking from "../../../images/AI_thinking.png";
import ai_idea from "../../../images/ai_idea.png";
import ai_welcome from "../../../images/Welcome_ai.png";
import selling_product from "../../../images/selling_product.png";
import recuritment from "../../../images/recuritment.png";
import therapist from "../../../images/therapist.png";

export default function StudyOneInstructionPageTwo(){
    return (
        <Container className="study-item">
            <Row>
                <h1 style={{ fontWeight: 'bold'}}>Let's Design the future with EAI! </h1>
            </Row>
            <br /><br />

            <figure style={{ width: "50%", margin: "0 auto" }}>
                        <img src={ai_welcome} alt="" style={{width:"100%"}}/>
                        
                    </figure>
        </Container>
        

    );
};